<template>
  <div class="p-4 lg:p-10 bg-gray min-h-screen">
    <header class="mb-10 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div>
        <h2 class="text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gray-600 tracking-tight">
          Descubrir
        </h2>
        <p class="text-dark font-medium mt-1">
          Encuentra a tu match ideal en <span class="text-blue-500">RED</span>.
        </p>
      </div>
      <!-- <div class="flex gap-2">
        <span class="px-4 py-2 bg-white rounded-full text-xs font-bold shadow-sm border border-pink-100 text-pink-500">Recientes</span>
        <span class="px-4 py-2 bg-white rounded-full text-xs font-bold shadow-sm border border-gray-100 text-gray-400">Cerca de ti</span>
      </div> -->
    </header>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 mb-12">

      <div
        v-for="profile in profiles"
        :key="profile.id"
        class="relative group bg-white rounded-[2.5rem] overflow-hidden shadow-[0_10px_30px_rgba(0,0,0,0.05)] hover:shadow-[0_20px_50px_rgba(236,72,153,0.15)] transition-all duration-500 cursor-pointer"
        @click="goToChat(profile)"
      >
        <div class="relative aspect-[3/4] overflow-hidden">
          <img
            :src="formatImageUrl(profile.photo_url)"
            class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            @contextmenu.prevent @click.stop
          />

          <div class="absolute top-4 right-4 z-20">
             <div class="bg-black/20 backdrop-blur-md px-3 py-1 rounded-full border border-white/30 text-white text-[10px] font-bold uppercase tracking-widest">
                Nicaragua
             </div>
          </div>

          <div class="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-black/90 via-black/40 to-transparent z-10"></div>

          <div class="absolute bottom-0 left-0 right-0 p-6 z-20">
            <div class="flex items-center gap-2 mb-2">
               <div v-if="profile.is_online==1" class="flex items-center gap-1.5 bg-green-500/20 backdrop-blur-sm px-2 py-0.5 rounded-md border border-green-500/50">
                  <span class="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse shadow-[0_0_8px_#4ade80]"></span>
                  <span class="text-[10px] text-green-300 font-bold uppercase">Online</span>
               </div>
               <div v-else class="flex items-center gap-1.5 bg-gray-500/20 backdrop-blur-sm px-2 py-0.5 rounded-md border border-gray-500/50">
                  <span class="w-1.5 h-1.5 bg-gray-400 rounded-full"></span>
                  <span class="text-[10px] text-gray-300 font-bold uppercase">Offline</span>
               </div>
            </div>

            <p class="text-white font-black text-2xl flex items-center gap-2">
              {{ profile.name }} <span class="font-light opacity-80">{{ profile.age }}</span>
            </p>

            <p class="text-white/70 text-xs mt-1 line-clamp-1 italic">
              "{{ profile.bio || '¡Hola! Hablemos un rato...' }}"
            </p>
          </div>
        </div>
      </div>

      <div v-if="!isPremium"
        class="relative group aspect-[3/4] rounded-[2.5rem] overflow-hidden border-2 border-dashed border-pink-200 flex flex-col items-center justify-center p-8 text-center bg-white hover:border-solid hover:border-pink-500 transition-all duration-500 cursor-pointer shadow-sm hover:shadow-2xl"
        @click="goToSubscription"
      >
        <div class="absolute -top-10 -right-10 w-32 h-32 bg-pink-100 rounded-full blur-3xl group-hover:bg-pink-200 transition-colors"></div>
        <div class="absolute -bottom-10 -left-10 w-32 h-32 bg-purple-100 rounded-full blur-3xl group-hover:bg-purple-200 transition-colors"></div>

        <div class="relative mb-6 p-5 bg-gradient-to-br from-pink-500 to-purple-600 rounded-3xl shadow-[0_10px_20px_rgba(236,72,153,0.3)] group-hover:rotate-12 transition-transform duration-500">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h3 class="text-2xl font-black text-gray-900 mb-3 relative">¿Buscas más?</h3>
        <p class="text-gray-500 text-sm mb-8 leading-relaxed relative">
          Desbloquea perfiles <span class="text-pink-600 font-bold">Premium</span> en todo el país.
        </p>

        <button class="relative bg-gray-900 text-white px-8 py-3 rounded-[1.5rem] font-black text-xs uppercase tracking-widest hover:bg-pink-600 hover:scale-105 transition-all shadow-xl active:scale-95">
          Ver planes
        </button>
      </div>

    </div>

    <div v-if="loading" class="flex flex-col items-center justify-center py-20 gap-4">
      <div class="w-12 h-12 border-4 border-blue-100 border-t-blue-500 rounded-full animate-spin"></div>
      <p class="text-gray-400 font-bold text-sm uppercase tracking-widest">Buscando Matches...</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/api' // Tu instancia global de Axios

const router = useRouter()
const profiles = ref([])
const loading = ref(true)
const isPremium = ref(false)
const interested_in = ref(false)
// Función para obtener los perfiles del backend
const fetchProfiles = async () => {
  try {
    const storageUser = localStorage.getItem('user')

    if (storageUser) {
      const userObj = JSON.parse(storageUser)
      isPremium.value = userObj.is_premium == 1

      // GUARDAMOS EL VALOR REAL (1, 2 o 3), NO UN BOOLEANO
      interested_in.value = userObj.interested_in
    }

    const response = await api.get('/ai_characters')

    // FILTRAMOS USANDO .value Y COMPARACIÓN SIMPLE (==) POR SI ACASO
    if (response.data && Array.isArray(response.data)) {
      profiles.value = response.data.filter(row => row.gender == interested_in.value);
    }

  } catch (error) {
    console.error("Error al cargar perfiles:", error)
  } finally {
    loading.value = false
  }
}

// Formatear la URL de la imagen (por si el backend manda ruta relativa)
const formatImageUrl = (url) => {
  if (!url) return ''
  if (url.startsWith('http')) return url
  // Si usas el mismo servidor para assets:
  const baseUrl = api.defaults.baseURL.split('index.php')[0]
  return baseUrl + url
}

const goToChat = (profile) => {
  // Ahora pasamos el ID como parámetro de ruta para que ChatView lo use
  router.push({
    name: 'Chat', // Asegúrate de que tu ruta se llame así en router/index.js
    params: { id: profile.id }
  })
}
const goToSubscription = () => {
  router.push('/settings/subscription')
}

onMounted(() => {
  fetchProfiles()
})
</script>